import { shrinkChevronIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const MinimizeAlt = createIcon({
  displayName: 'MinimizeAlt',
  paths: [
    'M903.313 419.353c0-23.552-19.115-42.667-42.667-42.667h-153.007l218.534-218.534c16.64-16.64 16.64-43.648 0-60.331-16.683-16.64-43.691-16.64-60.331 0l-218.53 218.53v-152.998c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667v256c0 23.553 19.115 42.668 42.667 42.668h256c23.552 0 42.667-19.115 42.667-42.668zM462.020 604.646c0-23.552-19.115-42.667-42.667-42.667h-256c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h153.007l-218.534 218.534c-16.64 16.64-16.64 43.648 0 60.331 16.683 16.64 43.691 16.64 60.331 0l218.53-218.53v152.998c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-256z'
  ],
  canvasPaths: canvasIconPaths(shrinkChevronIcon)
})
